import { isPercentageComplete } from "utils";

import { CropFootprintReturnBody, FarmFootprintReturnBody } from "models";

const formatPercentage = (v: number) => Number((parseFloat(v.toFixed(2)) / 100).toFixed(4));

const formatFraction = (v: number) => Number((v * 100).toFixed(2));

export const formatFractionDisplay = (v: number | null) => (v === null ? null : Math.round(v * 100));

export const formatPercentageInput = (v: number | null) => (v === null ? null : formatPercentage(v));

export const formatFractionInput = (v: number | null) => (v === null ? null : formatFraction(v));

export const formatKgToMetricTon = (v: number | null) => (v === null ? null : v / 1000);

export const formatMetricTonToKg = (v: number | null) => (v === null ? null : v * 1000);

interface FootprintingProgressResult {
  completionRate: number;
  isSubmitted: boolean;
  readyToSubmit: boolean;
  totalPayout: number;
}

/**
 * Calculates the total payout and completion rate for footprinting data
 * @param farmProgress - The farm's footprinting progress data
 * @param cropProgressQueries - Array of crop footprinting progress data
 * @returns Object containing totalPayout and completionRates
 */
export const calculateFootprintingProgress = (
  farmProgress: FarmFootprintReturnBody | undefined | null,
  cropProgresses: CropFootprintReturnBody[]
): FootprintingProgressResult => {
  if (!farmProgress) {
    return { isSubmitted: false, totalPayout: 0, readyToSubmit: false, completionRate: 0 };
  }

  const isSubmitted = (farmProgress.footprint?.isSubmitted ?? false) && cropProgresses.some((cp) => cp.footprint?.isSubmitted);
  const allForms = [farmProgress, ...cropProgresses];

  let totalPayout = 0;
  let completionRate = 0;

  allForms.forEach((item) => {
    completionRate += (item.completionPct || 0) / allForms.length;
    totalPayout += item.completionPayout || 0;
  });

  return {
    completionRate: isSubmitted ? 1 : completionRate,
    totalPayout,
    isSubmitted,
    readyToSubmit: !isSubmitted && isPercentageComplete(farmProgress.completionPct) && cropProgresses.some((cp) => isPercentageComplete(cp.completionPct)),
  };
};
